<lib-tooltip
  [tooltip]="tooltip()"
  [position]="tooltipPosition()"
  [visible]="isTooltipVisible"
>
  <button
    type="button"
    class="icon-button"
    [class.no-bg]="noBackground()"
    [style.backgroundColor]="backgroundColor()"
    [class.active]="active()"
    [style.width.px]="size()"
    [style.height.px]="size()"
    (click)="handleClick()"
    (mouseenter)="showTooltip()"
    (mouseleave)="hideTooltip()"
    (focusin)="showTooltip()"
    (focusout)="hideTooltip()"
    [attr.aria-label]="ariaLabel() || tooltip() || icon()"
    [attr.tabindex]="tabIndex() ?? null"
    [disabled]="disabled()"
  >
    @if (customIcon()) {
      <ng-container *ngTemplateOutlet="customIcon()"></ng-container>
    } @else {
      <i-feather
        [name]="icon()"
        [style.width.px]="size()! * 0.5"
        [style.height.px]="size()! * 0.5"
      ></i-feather>
    }

    <ng-content></ng-content>
  </button>
</lib-tooltip>
